"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableStyleCharacterPropertiesMergerUnderlineWordsOnly = exports.TableStyleCharacterPropertiesMergerStrikeoutWordsOnly = exports.TableStyleCharacterPropertiesMergerFontUnderlineType = exports.TableStyleCharacterPropertiesMergerFontStrikeoutType = exports.TableStyleCharacterPropertiesMergerUnderlineColor = exports.TableStyleCharacterPropertiesMergerStrikeoutColor = exports.TableStyleCharacterPropertiesMergerHighlightColor = exports.TableStyleCharacterPropertiesMergerFontItalic = exports.TableStyleCharacterPropertiesMergerFontSize = exports.TableStyleCharacterPropertiesMergerTextColor = exports.TableStyleCharacterPropertiesMergerShadingInfo = exports.TableStyleCharacterPropertiesMergerFontName = exports.TableStyleCharacterPropertiesMergerFontBold = exports.TableStyleCharacterPropertiesMergerNoProof = exports.TableStyleCharacterPropertiesMergerSmallCaps = exports.TableStyleCharacterPropertiesMergerAllCaps = exports.TableStyleCharacterPropertiesMergerScript = exports.TableStyleCharacterPropertiesMergerHidden = exports.TableStyleCharacterPropertiesMerger = void 0;
var tslib_1 = require("tslib");
var enums_1 = require("../../character/enums");
var table_cell_properties_merger_1 = require("./table-cell-properties-merger");
var table_properties_merger_base_1 = require("./table-properties-merger-base");
var TableStyleCharacterPropertiesMerger = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMerger, _super);
    function TableStyleCharacterPropertiesMerger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMerger.prototype.getContainerFromConditionalStyle = function (condStyle) {
        return condStyle.maskedCharacterProperties;
    };
    TableStyleCharacterPropertiesMerger.prototype.canUseValue = function (props) {
        return !!(props.getUseValue(this.getPropertyMask()));
    };
    TableStyleCharacterPropertiesMerger.prototype.getCondTableStyleFormattingListForThisContainer = function () {
        return table_cell_properties_merger_1.TableCellPropertiesMerger.conditionalTableStyleFormattingPriority;
    };
    TableStyleCharacterPropertiesMerger.prototype.actionBeforeDefaultValue = function () {
        this.result = null;
        return true;
    };
    TableStyleCharacterPropertiesMerger.prototype.getNotMergedProperty = function () {
        return new table_properties_merger_base_1.TableMergerNotMergedPropertyResult(false, null);
    };
    return TableStyleCharacterPropertiesMerger;
}(table_properties_merger_base_1.TablePropertiesMergerBase));
exports.TableStyleCharacterPropertiesMerger = TableStyleCharacterPropertiesMerger;
var TableStyleCharacterPropertiesMergerHidden = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerHidden, _super);
    function TableStyleCharacterPropertiesMergerHidden() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerHidden.prototype.getPropertyFromContainer = function (container) {
        return container.hidden;
    };
    TableStyleCharacterPropertiesMergerHidden.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseHidden;
    };
    return TableStyleCharacterPropertiesMergerHidden;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerHidden = TableStyleCharacterPropertiesMergerHidden;
var TableStyleCharacterPropertiesMergerScript = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerScript, _super);
    function TableStyleCharacterPropertiesMergerScript() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerScript.prototype.getPropertyFromContainer = function (container) {
        return container.script;
    };
    TableStyleCharacterPropertiesMergerScript.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseScript;
    };
    return TableStyleCharacterPropertiesMergerScript;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerScript = TableStyleCharacterPropertiesMergerScript;
var TableStyleCharacterPropertiesMergerAllCaps = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerAllCaps, _super);
    function TableStyleCharacterPropertiesMergerAllCaps() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerAllCaps.prototype.getPropertyFromContainer = function (container) {
        return container.allCaps;
    };
    TableStyleCharacterPropertiesMergerAllCaps.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseAllCaps;
    };
    return TableStyleCharacterPropertiesMergerAllCaps;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerAllCaps = TableStyleCharacterPropertiesMergerAllCaps;
var TableStyleCharacterPropertiesMergerSmallCaps = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerSmallCaps, _super);
    function TableStyleCharacterPropertiesMergerSmallCaps() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerSmallCaps.prototype.getPropertyFromContainer = function (container) {
        return container.smallCaps;
    };
    TableStyleCharacterPropertiesMergerSmallCaps.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseSmallCaps;
    };
    return TableStyleCharacterPropertiesMergerSmallCaps;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerSmallCaps = TableStyleCharacterPropertiesMergerSmallCaps;
var TableStyleCharacterPropertiesMergerNoProof = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerNoProof, _super);
    function TableStyleCharacterPropertiesMergerNoProof() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerNoProof.prototype.getPropertyFromContainer = function (container) {
        return container.noProof;
    };
    TableStyleCharacterPropertiesMergerNoProof.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseNoProof;
    };
    return TableStyleCharacterPropertiesMergerNoProof;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerNoProof = TableStyleCharacterPropertiesMergerNoProof;
var TableStyleCharacterPropertiesMergerFontBold = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerFontBold, _super);
    function TableStyleCharacterPropertiesMergerFontBold() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerFontBold.prototype.getPropertyFromContainer = function (container) {
        return container.fontBold;
    };
    TableStyleCharacterPropertiesMergerFontBold.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseFontBold;
    };
    return TableStyleCharacterPropertiesMergerFontBold;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerFontBold = TableStyleCharacterPropertiesMergerFontBold;
var TableStyleCharacterPropertiesMergerFontName = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerFontName, _super);
    function TableStyleCharacterPropertiesMergerFontName() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerFontName.prototype.getPropertyFromContainer = function (container) {
        return container.fontInfo;
    };
    TableStyleCharacterPropertiesMergerFontName.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseFontName;
    };
    return TableStyleCharacterPropertiesMergerFontName;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerFontName = TableStyleCharacterPropertiesMergerFontName;
var TableStyleCharacterPropertiesMergerShadingInfo = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerShadingInfo, _super);
    function TableStyleCharacterPropertiesMergerShadingInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerShadingInfo.prototype.getPropertyFromContainer = function (container) {
        return container.shadingInfo;
    };
    TableStyleCharacterPropertiesMergerShadingInfo.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseShadingInfoIndex;
    };
    return TableStyleCharacterPropertiesMergerShadingInfo;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerShadingInfo = TableStyleCharacterPropertiesMergerShadingInfo;
var TableStyleCharacterPropertiesMergerTextColor = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerTextColor, _super);
    function TableStyleCharacterPropertiesMergerTextColor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerTextColor.prototype.getPropertyFromContainer = function (container) {
        return container.textColor;
    };
    TableStyleCharacterPropertiesMergerTextColor.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseForeColorIndex;
    };
    return TableStyleCharacterPropertiesMergerTextColor;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerTextColor = TableStyleCharacterPropertiesMergerTextColor;
var TableStyleCharacterPropertiesMergerFontSize = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerFontSize, _super);
    function TableStyleCharacterPropertiesMergerFontSize() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerFontSize.prototype.getPropertyFromContainer = function (container) {
        return container.fontSize;
    };
    TableStyleCharacterPropertiesMergerFontSize.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseDoubleFontSize;
    };
    return TableStyleCharacterPropertiesMergerFontSize;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerFontSize = TableStyleCharacterPropertiesMergerFontSize;
var TableStyleCharacterPropertiesMergerFontItalic = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerFontItalic, _super);
    function TableStyleCharacterPropertiesMergerFontItalic() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerFontItalic.prototype.getPropertyFromContainer = function (container) {
        return container.fontItalic;
    };
    TableStyleCharacterPropertiesMergerFontItalic.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseFontItalic;
    };
    return TableStyleCharacterPropertiesMergerFontItalic;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerFontItalic = TableStyleCharacterPropertiesMergerFontItalic;
var TableStyleCharacterPropertiesMergerHighlightColor = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerHighlightColor, _super);
    function TableStyleCharacterPropertiesMergerHighlightColor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerHighlightColor.prototype.getPropertyFromContainer = function (container) {
        return container.highlightColor;
    };
    TableStyleCharacterPropertiesMergerHighlightColor.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseStrikeoutColorIndex;
    };
    return TableStyleCharacterPropertiesMergerHighlightColor;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerHighlightColor = TableStyleCharacterPropertiesMergerHighlightColor;
var TableStyleCharacterPropertiesMergerStrikeoutColor = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerStrikeoutColor, _super);
    function TableStyleCharacterPropertiesMergerStrikeoutColor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerStrikeoutColor.prototype.getPropertyFromContainer = function (container) {
        return container.strikeoutColor;
    };
    TableStyleCharacterPropertiesMergerStrikeoutColor.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseStrikeoutColorIndex;
    };
    return TableStyleCharacterPropertiesMergerStrikeoutColor;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerStrikeoutColor = TableStyleCharacterPropertiesMergerStrikeoutColor;
var TableStyleCharacterPropertiesMergerUnderlineColor = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerUnderlineColor, _super);
    function TableStyleCharacterPropertiesMergerUnderlineColor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerUnderlineColor.prototype.getPropertyFromContainer = function (container) {
        return container.underlineColor;
    };
    TableStyleCharacterPropertiesMergerUnderlineColor.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseUnderlineColorIndex;
    };
    return TableStyleCharacterPropertiesMergerUnderlineColor;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerUnderlineColor = TableStyleCharacterPropertiesMergerUnderlineColor;
var TableStyleCharacterPropertiesMergerFontStrikeoutType = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerFontStrikeoutType, _super);
    function TableStyleCharacterPropertiesMergerFontStrikeoutType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerFontStrikeoutType.prototype.getPropertyFromContainer = function (container) {
        return container.fontStrikeoutType;
    };
    TableStyleCharacterPropertiesMergerFontStrikeoutType.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseFontStrikeoutType;
    };
    return TableStyleCharacterPropertiesMergerFontStrikeoutType;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerFontStrikeoutType = TableStyleCharacterPropertiesMergerFontStrikeoutType;
var TableStyleCharacterPropertiesMergerFontUnderlineType = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerFontUnderlineType, _super);
    function TableStyleCharacterPropertiesMergerFontUnderlineType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerFontUnderlineType.prototype.getPropertyFromContainer = function (container) {
        return container.fontUnderlineType;
    };
    TableStyleCharacterPropertiesMergerFontUnderlineType.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseFontUnderlineType;
    };
    return TableStyleCharacterPropertiesMergerFontUnderlineType;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerFontUnderlineType = TableStyleCharacterPropertiesMergerFontUnderlineType;
var TableStyleCharacterPropertiesMergerStrikeoutWordsOnly = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerStrikeoutWordsOnly, _super);
    function TableStyleCharacterPropertiesMergerStrikeoutWordsOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerStrikeoutWordsOnly.prototype.getPropertyFromContainer = function (container) {
        return container.strikeoutWordsOnly;
    };
    TableStyleCharacterPropertiesMergerStrikeoutWordsOnly.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseStrikeoutWordsOnly;
    };
    return TableStyleCharacterPropertiesMergerStrikeoutWordsOnly;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerStrikeoutWordsOnly = TableStyleCharacterPropertiesMergerStrikeoutWordsOnly;
var TableStyleCharacterPropertiesMergerUnderlineWordsOnly = (function (_super) {
    tslib_1.__extends(TableStyleCharacterPropertiesMergerUnderlineWordsOnly, _super);
    function TableStyleCharacterPropertiesMergerUnderlineWordsOnly() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableStyleCharacterPropertiesMergerUnderlineWordsOnly.prototype.getPropertyFromContainer = function (container) {
        return container.underlineWordsOnly;
    };
    TableStyleCharacterPropertiesMergerUnderlineWordsOnly.prototype.getPropertyMask = function () {
        return enums_1.CharacterPropertiesMask.UseUnderlineWordsOnly;
    };
    return TableStyleCharacterPropertiesMergerUnderlineWordsOnly;
}(TableStyleCharacterPropertiesMerger));
exports.TableStyleCharacterPropertiesMergerUnderlineWordsOnly = TableStyleCharacterPropertiesMergerUnderlineWordsOnly;
